import React from 'react/addons';
import Fluxxor from 'fluxxor';
/* eslint-disable new-cap */
var FluxMixin = Fluxxor.FluxMixin(React);
/* eslint-enable new-cap */

import DatePicker from 'ofs/components/daterange/DatePicker';

import {gettext} from 'ofs/i18n';

function noop() {}

var MESSAGES = {
  ARRIVAL_DATE: gettext('Arrival date'),
  DEPARTURE_DATE: gettext('Departure date'),
  SELECT_DATE: gettext('Select date')
};


var DateInputs = React.createClass({
  mixins: [FluxMixin],

  propTypes: {
    initialStartValue: React.PropTypes.instanceOf(Date),
    initialEndValue: React.PropTypes.instanceOf(Date),
    startField: React.PropTypes.string.isRequired,
    endField: React.PropTypes.string.isRequired,
    stateDefinitions: React.PropTypes.object,
    dateStates: React.PropTypes.array,
    defaultState: React.PropTypes.string,
    labels: React.PropTypes.bool,
    onSelect: React.PropTypes.func
  },

  getDefaultProps() {
    return {
      onSelect: noop
    };
  },

  getInitialState() {
    return {
      startValue: this.props.initialStartValue,
      endValue: this.props.initialEndValue
    };
  },

  getDateState(startValue, endValue) {
    var state = {startValue, endValue};

    if (startValue && startValue > endValue) {
      // if start value is after end value then reset end value
      state.endValue = null;
    }

    return state;
  },

  handleStartSelect(value) {
    var state = this.getDateState(value.toDate(), this.state.endValue);
    this.setState(state);

    if (state.startValue && state.endValue) {
      this.props.onSelect(state.startValue, state.endValue);
    }
  },

  handleEndSelect(value) {
    var state = this.getDateState(this.state.startValue, value.toDate());
    this.setState(state);

    if (state.startValue && state.endValue) {
      this.props.onSelect(state.startValue, state.endValue);
    }
  },

  render() {
    var {
      startField,
      endField,
      labels,
      stateDefinitions,
      dateStates,
      defaultState
    } = this.props;
    var {startValue, endValue} = this.state;

    var initialEndDate;
    if (startValue) {
      initialEndDate = {
        month: startValue.getMonth(),
        year: startValue.getFullYear()
      };
    }

    return (
      <div>
        <DatePicker value={startValue} name={startField}
          stateDefinitions={stateDefinitions}
          dateStates={dateStates}
          defaultState={defaultState}
          label={labels ? MESSAGES['ARRIVAL_DATE'] : null}
          placeholder={MESSAGES['SELECT_DATE']}
          onSelect={this.handleStartSelect} />

        <DatePicker value={endValue} name={endField}
          stateDefinitions={stateDefinitions}
          dateStates={dateStates}
          defaultState={defaultState}
          label={labels ? MESSAGES['DEPARTURE_DATE'] : null}
          placeholder={MESSAGES['SELECT_DATE']}
          initialDate={initialEndDate}
          onSelect={this.handleEndSelect} />
      </div>
    );
  }
});

export default DateInputs;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/views/DateInputs.jsx
 **/